import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'vtr-widget-snapshot',
	templateUrl: './widget-snapshot.component.html',
	styleUrls: ['./widget-snapshot.component.scss'],
})
export class WidgetSnapshotComponent {
	@Input() itemParent: string;

	constructor(private router: Router) {}

	navigateToSnapshotPage() {
		this.router.navigate(['/snapshot']);
	}
}
